import type { IconSvgObject } from './types';

const MoveDownLeftIcon: IconSvgObject = [
  ["path", { d: "M5.40629 12C5.38762 13.3135 4.48396 17.6636 5.4063 18.5859C6.32862 19.5082 10.6787 18.6046 11.9922 18.5859", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M19.5225 5.53033C19.8154 5.23744 19.8154 4.76256 19.5225 4.46967C19.2296 4.17678 18.7548 4.17678 18.4619 4.46967L18.9922 5L19.5225 5.53033ZM5.46186 17.4697C5.16896 17.7626 5.16896 18.2374 5.46186 18.5303C5.75475 18.8232 6.22962 18.8232 6.52252 18.5303L5.99219 18L5.46186 17.4697ZM18.9922 5L18.4619 4.46967L5.46186 17.4697L5.99219 18L6.52252 18.5303L19.5225 5.53033L18.9922 5Z", fill: "currentColor", key: "1" }]
];

export default MoveDownLeftIcon;
